/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CouponCode
 */
export interface CouponCode {
    /**
     * 
     * @type {string}
     * @memberof CouponCode
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponCode
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CouponCode
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof CouponCode
     */
    maxUsage?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CouponCode
     */
    waiveProcessingFees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CouponCode
     */
    useFixedDiscount?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponCode
     */
    discountValue?: number;
    /**
     * 
     * @type {Date}
     * @memberof CouponCode
     */
    expirationDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CouponCode
     */
    isActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CouponCode
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponCode
     */
    courierId?: number;
}

/**
 * Check if a given object implements the CouponCode interface.
 */
export function instanceOfCouponCode(value: object): value is CouponCode {
    return true;
}

export function CouponCodeFromJSON(json: any): CouponCode {
    return CouponCodeFromJSONTyped(json, false);
}

export function CouponCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponCode {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'code': json['code'] == null ? undefined : json['code'],
        'maxUsage': json['maxUsage'] == null ? undefined : json['maxUsage'],
        'waiveProcessingFees': json['waiveProcessingFees'] == null ? undefined : json['waiveProcessingFees'],
        'useFixedDiscount': json['useFixedDiscount'] == null ? undefined : json['useFixedDiscount'],
        'discountValue': json['discountValue'] == null ? undefined : json['discountValue'],
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'id': json['id'] == null ? undefined : json['id'],
        'courierId': json['courierId'] == null ? undefined : json['courierId'],
    };
}

export function CouponCodeToJSON(json: any): CouponCode {
    return CouponCodeToJSONTyped(json, false);
}

export function CouponCodeToJSONTyped(value?: CouponCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'code': value['code'],
        'maxUsage': value['maxUsage'],
        'waiveProcessingFees': value['waiveProcessingFees'],
        'useFixedDiscount': value['useFixedDiscount'],
        'discountValue': value['discountValue'],
        'expirationDate': value['expirationDate'] == null ? undefined : ((value['expirationDate']).toISOString()),
        'isActive': value['isActive'],
        'id': value['id'],
        'courierId': value['courierId'],
    };
}

